const css = `@charset "UTF-8";
.employees-header-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
@media (max-width: 576px) {
  .employees-header-options {
    gap: 8px;
    /* Ajustar botones para dispositivos móviles */
  }
  .employees-header-options > button,
  .employees-header-options > div {
    margin-bottom: 8px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL0VtcGxveWVlcy9FbXBsb3llZXNMaXN0Iiwic291cmNlcyI6WyJFbXBsb3llZXNMaXN0LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFORjtJQU9JO0FBRUE7O0VBQ0E7QUFBQTtJQUVFIiwic291cmNlc0NvbnRlbnQiOlsiLmVtcGxveWVlcy1oZWFkZXItb3B0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgZ2FwOiA4cHg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG5cbiAgQG1lZGlhIChtYXgtd2lkdGg6IDU3NnB4KSB7XG4gICAgZ2FwOiA4cHg7XG5cbiAgICAvKiBBanVzdGFyIGJvdG9uZXMgcGFyYSBkaXNwb3NpdGl2b3MgbcOzdmlsZXMgKi9cbiAgICA+IGJ1dHRvbixcbiAgICA+IGRpdiB7XG4gICAgICBtYXJnaW4tYm90dG9tOiA4cHg7XG4gICAgfVxuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
